"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishNames = void 0;
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const membership_1 = require("modules/membership");
var PublishNames;
(function (PublishNames) {
    PublishNames["Ok"] = "PublishOk";
    PublishNames["Cancel"] = "PublishCancel";
})(PublishNames || (exports.PublishNames = PublishNames = {}));
const GROUP_NAME = 'Content Publish';
class DatahubPublishService {
}
DatahubPublishService.publish = () => {
    DatahubService_1.default.sendMetrify({
        group: GROUP_NAME,
        name: PublishNames.Ok,
        user: { id: membership_1.MembershipStore.marketplaceId }
    });
};
DatahubPublishService.cancel = () => {
    DatahubService_1.default.sendMetrify({
        group: GROUP_NAME,
        name: PublishNames.Cancel,
        user: { id: membership_1.MembershipStore.marketplaceId }
    });
};
exports.default = DatahubPublishService;
